module.exports = __webpack_public_path__ + "img/directory--icon.c27e47d0.svg";